import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BtAchAccountsComponent } from '../../ui/bt-ach-accounts/bt-ach-accounts.component';
import { Subject, takeUntil } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { BtMicroDepositVerificationComponent } from '../../ui/bt-micro-deposit-verification/bt-micro-deposit-verification.component';
import { BraintreeService } from '../../data-access/braintree.service';
import { BtAccountAddedDialogComponent } from '../../ui/bt-account-added-dialog/bt-account-added-dialog.component';
import { PaymentsService } from '../../data-access/payments.service';
import { IBtUsBankAccount } from '../../interfaces/braintree.interfaces';

@Component({
  selector: 'equine-ui-nx-account-verification',
  standalone: true,
  imports: [
    CommonModule,
    BtAchAccountsComponent,
    
  ],
  templateUrl: './account-verification.component.html',
  styleUrl: './account-verification.component.scss',
})
export class AccountVerificationComponent implements OnInit, OnDestroy {
  
  braintreeService = inject(BraintreeService);
  paymentsService = inject(PaymentsService);
  dialog = inject(MatDialog);
  unsubscribe$ = new Subject<void>();
  
  paymentMethods: IBtUsBankAccount[] = [];

  private userLoggedInId = this.paymentsService.getLoggedInUserId() || '';

  ngOnInit(): void {
    this.getBraintreeTokenAndCustomerData();
  }

   getBraintreeTokenAndCustomerData() {
      this.braintreeService.getBraintreeTokenAndCustomerData(this.userLoggedInId)
      .pipe(
        takeUntil(this.unsubscribe$)
      )
      .subscribe({
        next: (response) => {
          this.paymentMethods = (response.btCustomer.usBankAccounts as IBtUsBankAccount[]).filter(each => !each.verified);
        }
      });
    }


    openVerificationDialog(account: IBtUsBankAccount) {
      const verificationDialogRef = this.dialog.open(BtMicroDepositVerificationComponent, {
        disableClose: true,
        data: {
          bankName: account.bankName,
          last4: account.last4
        }
      });
  
      verificationDialogRef.componentInstance.submitMicroDeposit
        .pipe(
          takeUntil(this.unsubscribe$)
        )
        .subscribe({
          next: (microdeposits: number[]) => {
            verificationDialogRef.componentInstance.loading = true;
            verificationDialogRef.componentInstance.form.disable();
  
            this.braintreeService.verifyAccount(account.verifications[0].id, microdeposits)
              .pipe(takeUntil(this.unsubscribe$))
              .subscribe({
                next: (response) => {
                  verificationDialogRef.close();
                  this.dialog.open(BtAccountAddedDialogComponent, {
                    data: {verified: true}
                  });
                  this.getBraintreeTokenAndCustomerData();
                },
                error: (errorResponse) => {
                  this.dialog.open(BtAccountAddedDialogComponent, {
                    data: {
                      verified: false,
                      message: 2,
                      messageError: errorResponse.error.message
                    }
                  });
  
                  if (errorResponse.error?.message === 'Too many confirmation attempts.') {
                    verificationDialogRef.close();
                  } else {
                    verificationDialogRef.componentInstance.form.reset();
                    verificationDialogRef.componentInstance.form.enable();
    
                    verificationDialogRef.componentInstance.loading = false;
                  }
                }
              });
          }
        });
  
    }

    ngOnDestroy(): void {
      this.unsubscribe$.next();
      this.unsubscribe$.complete();
    }

}
